var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGlobe24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.885 21.26a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3.885 12.26h18",
  stroke: "#7084B4",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.885 3.26c2.501 2.465 3.923 5.664 4 9-.078 3.338-1.499 6.536-4 9-2.502-2.464-3.923-5.662-4-9 .077-3.336 1.498-6.535 4-9v0Z",
  stroke: "#7084B4",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgGlobe24Px;